import { render } from "./GetToKnowUs.vue?vue&type=template&id=2a3c5587"
import script from "./GetToKnowUs.vue?vue&type=script&lang=js"
export * from "./GetToKnowUs.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__